import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import { FiHeart, FiMinus, FiPlus, FiRefreshCw, FiShield, FiTruck } from "react-icons/fi";
import siteConfig from "../siteConfig";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart, wishlist, toggleWishlist } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail">
      <nav className="product-breadcrumb page-shell" aria-label="Breadcrumb">
        <Link to="/">Home</Link><span>/</span><Link to="/shop">Shop</Link><span>/</span><span>{product.name}</span>
      </nav>
      <section className="product-heading page-shell">
        <div><p>{product.category} · NEW ARRIVAL</p><h1 className="product-name">{product.name}</h1></div>
        <div className="product-price">{siteConfig.currencySymbol}{Number(product.price).toFixed(2)} <small>{siteConfig.currency}</small></div>
      </section>
      <div className="product-detail__container">
        <div className="gallery-column">
          {product.images.map((img, idx) => <figure className="product-shot" key={img}><img src={img} alt={`${product.name} — view ${idx + 1}`} /><figcaption>{idx === 0 ? "Product view" : "Detail view"}</figcaption></figure>)}
        </div>

        <aside className="product-info product-buy-card">
          <div className="product-meta">
            <div className="product-brand">{product.brand}</div>
            <h2>Designed for the everyday</h2>
          </div>

          <div className="product-description lead">
            {product.description.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
          </div>

          <div className="product-options">
            <div className="sizes">
              <div className="label">Color :</div>
              <select
                value={selectedColor}
                onChange={(e) => setSelectedColor(e.target.value)}
                aria-label="Choose a color"
              >
                {product.colors.map((s, idx) => (
                  <option key={idx} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>

            <div className="sizes">
              <div className="label">Size :</div>
              <select
                value={selectedSize}
                onChange={(e) => setSelectedSize(e.target.value)}
                aria-label="Choose your size"
              >
                {product.size.map((s, idx) => (
                  <option key={idx} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="product-purchase-row">
            <div className="detail-quantity" aria-label="Quantity selector">
              <button onClick={() => setQuantity((value) => Math.max(1, value - 1))} aria-label="Decrease quantity"><FiMinus /></button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity((value) => value + 1)} aria-label="Increase quantity"><FiPlus /></button>
            </div>
          </div>

          <div className="product-actions">
            <button className="add-to-cart" onClick={handleAddToCart}>
              Add to cart
            </button>
            <button className={`wish ${wishlist.includes(product.id) ? "active" : ""}`} onClick={() => toggleWishlist(product.id)} aria-label="Toggle wishlist"><FiHeart /></button>
          </div>

          <div className="purchase-assurances">
            <p><FiTruck /><span><strong>$9.99 flat-rate shipping</strong><small>Prepared in 2–4 business days</small></span></p>
            <p><FiRefreshCw /><span><strong>14-day return requests</strong><small>For eligible unused items in original condition</small></span></p>
            <p><FiShield /><span><strong>Secure checkout</strong><small>Payment handled by our encrypted provider</small></span></p>
          </div>
        </aside>
      </div>
      <section className="product-story page-shell">
        <article className="story-intro"><p className="detail-kicker">WHY YOU'LL LIKE IT</p><h2>Useful details, without the clutter.</h2><p>{product.description[0]}</p><p>{product.description[1]}</p></article>
        <article><p className="detail-kicker">HIGHLIGHTS</p><ul>{product.Features.map((feature) => <li key={feature}>{feature}</li>)}</ul></article>
        <article><p className="detail-kicker">PRODUCT DETAILS</p><dl><div><dt>Material</dt><dd>{product.material}</dd></div><div><dt>Ideal for</dt><dd>{product.details.idealFor}</dd></div><div><dt>Finish</dt><dd>{product.details.finish}</dd></div><div><dt>In the box</dt><dd>{product.details.packageContents}</dd></div></dl></article>
      </section>
      <section className="care-panel page-shell"><div><p className="detail-kicker">CARE GUIDE</p><h2>Keep it looking its best</h2></div><div><p>{product.details.care}</p><p className="product-note">{product.details.note}</p></div></section>
    </div>
  );
};

export default ProductDetail;
